import { UserAccess } from 'areas/users/models/userAccess';

export class PrincipalsCollection {
  /**
   * The authenticated principal
   */
  public primaryPrincipal: Principal = new Principal();

  // Note: although it's redundant to suffix the above properties with 'principal' it makes the destructured names clearer where PrincipalContext is used.
}

export interface IPrincipal {
  identity: Identity;
  isGssAdministrator: boolean;
  hasMultipleClientAccounts: boolean;
  access: UserAccess;
}

export class Principal {
  public identity: Identity = new Identity();
  public isGssAdministrator: boolean = false;
  public hasMultipleClientAccounts: boolean = false;
  public access!: UserAccess;
  public impersonator?: string;
}

export class Identity {
  public isAuthenticated: boolean = false;
  public userId!: string;
  public username!: string;
  public name!: string;
  public clientAccount!: ClientAccount;
}

export class ClientAccount {
  public id!: number;
  public name!: string;
}

